import { render, staticRenderFns } from "./analysts.vue?vue&type=template&id=2b0e6ec6"
import script from "./analysts.vue?vue&type=script&lang=js"
export * from "./analysts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports